module.exports = __webpack_public_path__ + "static/media/thumb-up.94dcfada.svg";